<template>
  <div>
    <div v-if="options">
      <div class="d-flex flex-row flex-wrap">
        <v-card
          flat
          :max-width="theMaxWidth"
          :width="theWidth"
          class="mr-2 mb-2 pointer grayBorder px-3 py-1"
          :color="i == choice ? '#fff2d7' : '#fdfdfd'"
          v-for="(option, i) in options"
          :key="i"
          @click="setChoice(i)"
        >
          <v-icon v-if="option.icon" class="mr-1" small color="primary"
            >mdi-{{ option.icon }}</v-icon
          >
          {{ option.name }}
        </v-card>
      </div>
      <v-fade-transition>
        <div v-if="choice != null" class="mt-4">
          <div
            v-if="options[choice].question"
            class="font-weight-bold mb-2 d-flex flex-row"
          >
            <div class="pr-6">{{ options[choice].question }}</div>
            <definition-list-dialog
              v-if="options[choice].definitions"
              :definitionList="options[choice].definitions"
              :definitions="definitions"
            ></definition-list-dialog>
          </div>
          <v-slide-y-transition>
            <coding-widget-element
              v-if="options[choice].options"
              :options="options[choice].options"
              :definitions="definitions"
              @problem="problem = $event"
              @activeDefinitions="childDefinitions = $event"
            ></coding-widget-element>
          </v-slide-y-transition>
        </div>
      </v-fade-transition>
    </div>
  </div>
</template>

<script>
import CodingWidgetElement from "./CodingWidgetElement.vue";

export default {
  name: "CodingWidgetElement",
  components: {
    CodingWidgetElement,
    DefinitionListDialog: () =>
      import("@/components/universalStuff/DefinitionListDialog.vue"),
  },
  props: { options: null, definitions: null, clearForm: null, wide: null },
  data: function () {
    return {
      choice: null,
      loading: false,
      problem: null,
      childDefinitions: [],
    };
  },
  methods: {
    setChoice(val) {
      this.choice = val;
      this.emitActiveDefinitions();
      // this.briefLoading();
      this.$emit("canClearForm", val === null ? false : true);
    },
    emitActiveDefinitions() {
      let defs = this.childDefinitions ? [...this.childDefinitions] : [];
      let localDef =
        this.choice != null ? this.options[this.choice]?.definition : null;
      if (localDef && !defs.includes(localDef)) {
        defs.push(localDef);
      }
      defs.reverse();
      // console.log("emitActiveDefinitions", defs);
      this.$emit("activeDefinitions", defs);
    },
  },
  computed: {
    selectedCode: function () {
      return this.choice != null ? this.options[this.choice].code : null;
    },
    // activeDefinitions: function () {
    //   let defs = this.childDefinitions ? this.childDefinitions : [];
    //   let localDef =
    //     this.choice != null ? this.options[this.choice]?.definition : null;
    //   if (localDef && !defs.includes(localDef)) {
    //     defs.push(localDef);
    //   }
    //   return defs;
    // },
    theWidth: function () {
      if (this.wide) return this.wide;
      return this.$vuetify.breakpoint.smAndUp ? null : "100%";
    },

    theMaxWidth: function () {
      if (this.wide) return null;
      return this.$vuetify.breakpoint.smAndUp ? 180 : "100%";
    },
  },
  watch: {
    options() {
      this.choice = null;
      //   this.loading = true;
    },
    clearForm(val) {
      // console.log("clearForm", val);
      if (val) {
        this.setChoice(null);
        this.problem = null;
      }
      // console.log("clearForm", val);
    },
    selectedCode(val) {
      this.$emit("problem", val);
    },
    problem(val) {
      this.$emit("problem", val);
    },
    childDefinitions(val) {
      this.emitActiveDefinitions(val);
    },
    // activeDefinitions(val) {
    //   this.$emit("activeDefinitions", val);
    // },
  },
};
</script>

<style scoped>
.shady {
  background-color: #eeeeee;
}
</style>
